/**
 * This is a helper function to make `window.locale` and `window.moment_locale` persistent while
 * navigating outside of the React Router context.
 *
 * @returns {string} A string of URL query parameters for locale and moment_locale or an
 * empty string if both are 'en'.
 */
export function createLocaleQueryParams() {
  const locale = window.locale || null
  const momentLocale = window.moment_locale || null

  if ((!locale && !momentLocale) || (locale === 'en' && momentLocale === 'en')) {
    return ''
  }

  if (locale && !momentLocale) {
    return `?locale=${locale}`
  }

  if (!locale && momentLocale) {
    return `?moment_locale=${momentLocale}`
  }

  return `?locale=${locale}&moment_locale=${momentLocale}`
}
